import { render, staticRenderFns } from "./wind.vue?vue&type=template&id=cbf5780c&"
import script from "./wind.vue?vue&type=script&lang=js&"
export * from "./wind.vue?vue&type=script&lang=js&"
import style0 from "./wind.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports